import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  Button,
  Table
} from "reactstrap";
import LoaderSpinner from "../../Widgets/LoaderSpinner";

const ViewPartners = props => {
  const [isFetching, setIsFetching] = useState(false);
  const [partners, setPartners] = useState([]);
  const [filteredPartners, setFilteredPartners] = useState([]);
  const [query, setQuery] = useState("");
  const [redirectURL, setRedirectURL] = useState(null);

  const fetchPartners = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      setIsFetching(true);

      const { data } = await axios.get("/api/proxy/v2/partneradmin", {
        headers
      });

      setPartners(data);
      setFilteredPartners(data);
    } catch (e) {
      console.log(e.response);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  useEffect(
    () => {
      filterPartners();
    },
    [query]
  );

  const filterPartners = () => {
    const filtered = partners.filter(
      partner => partner.id.includes(query) || partner.name.includes(query)
    );
    setFilteredPartners(filtered);
  };

  const viewPartner = id => {
    return () => {
      setRedirectURL(`/partners/${id}`);
    };
  };

  const renderPartners = () => {
    return filteredPartners.map(partner => (
      <tr
        onClick={viewPartner(partner.id)}
        key={partner.id}
        className="user-table__item"
      >
        <td>
          <div>{partner.name}</div>
        </td>
        <td className="text-center">{partner.id}</td>
      </tr>
    ));
  };

  const onQuery = e => {
    setQuery(e.target.value);
  };

  if (redirectURL) {
    return <Redirect to={redirectURL} />;
  }

  return (
    <Row>
      <Col xs="12">
        <Card>
          <CardHeader>Filter by Name or Id</CardHeader>
          <CardBody>
            <Input type="text" onChange={onQuery} value={query} />
          </CardBody>
        </Card>

        {isFetching && <LoaderSpinner />}

        {partners.length ? (
          <Table
            hover
            responsive
            className="table-outline mb-0 d-none d-sm-table user-table"
            key="table"
          >
            <thead className="thead-light">
              <tr>
                <th>Name</th>
                <th className="text-center">ID</th>
              </tr>
              {renderPartners()}
            </thead>
            <tbody />
          </Table>
        ) : null}
      </Col>
    </Row>
  );
};

export default ViewPartners;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/ViewPartners.js